module.exports = __webpack_public_path__ + "img/hatchery.d449e536.svg";